/* ░░ SPUMA (DE): interactions ░░ */
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// ── Nav background on scroll ──
const nav = document.getElementById('nav');
const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 30);
onScroll();
window.addEventListener('scroll', onScroll, { passive: true });

// ── Mobile burger menu ──
(function () {
  const burger = document.getElementById('burger');
  const menu = document.getElementById('mobileMenu');
  if (!burger || !menu) return;

  const open = () => {
    menu.classList.add('open');
    menu.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('menu-open');
  };
  const close = () => {
    menu.classList.remove('open');
    menu.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
  };
  const toggle = () => (menu.classList.contains('open') ? close() : open());

  burger.addEventListener('click', toggle);
  menu.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', close));
  // Close after tapping any in-page link (hash targets); external links navigate away anyway.
  menu.querySelectorAll('.mmenu__link').forEach((a) => a.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();

// ── Reveal sections on scroll ──
const io = new IntersectionObserver((entries) => {
  entries.forEach((e) => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  });
}, { threshold: 0.12 });
document.querySelectorAll('.section').forEach((s) => io.observe(s));

// ── Stat count-up (strip) ──
(function () {
  const strip = document.querySelector('.strip');
  if (!strip) return;
  const nums = [...strip.querySelectorAll('.strip__item b')].filter((b) => b.querySelector('span'));
  const run = (b) => {
    const suffix = b.querySelector('span').outerHTML;
    const target = parseInt(b.textContent, 10) || 0;
    if (reduce || target === 0) { return; }
    const dur = 1100, t0 = performance.now();
    const tick = (now) => {
      const p = Math.min((now - t0) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      b.innerHTML = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  const ob = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { nums.forEach(run); ob.disconnect(); } });
  }, { threshold: 0.5 });
  ob.observe(strip);
})();

// ── Hero parallax + idle float (single rAF loop) ──
(function () {
  const product = document.querySelector('.hero__product');
  const blob = document.querySelector('.blob--1');
  const hero = document.querySelector('.hero');
  if (!product || !hero) return;
  if (reduce) { product.classList.add('idle'); return; }

  let tx = 0, ty = 0, cx = 0, cy = 0; // pointer target / current (lerped)
  hero.addEventListener('pointermove', (e) => {
    const r = hero.getBoundingClientRect();
    tx = (e.clientX - r.left) / r.width - 0.5;
    ty = (e.clientY - r.top) / r.height - 0.5;
  });
  hero.addEventListener('pointerleave', () => { tx = 0; ty = 0; });

  const t0 = performance.now();
  const loop = (now) => {
    cx += (tx - cx) * 0.08;
    cy += (ty - cy) * 0.08;
    const bob = Math.sin((now - t0) / 1400) * 10;       // idle float
    const scrollShift = Math.min(window.scrollY, 700) * 0.05;
    product.style.transform =
      `translate(${cx * 16}px, ${cy * 16 + bob - scrollShift}px)`;
    if (blob) blob.style.transform = `translate(${cx * -26}px, ${cy * -26}px)`;
    requestAnimationFrame(loop);
  };
  requestAnimationFrame(loop);
})();

// ── Product gallery: click a thumbnail to swap the main image ──
(function () {
  const main = document.getElementById('galMain');
  const thumbs = document.getElementById('galThumbs');
  if (!main || !thumbs) return;
  thumbs.addEventListener('click', (e) => {
    const btn = e.target.closest('.pgal__thumb');
    if (!btn) return;
    main.style.opacity = '0';
    const src = btn.dataset.src;
    const swap = () => { main.src = src; main.style.opacity = '1'; };
    setTimeout(swap, 120);
    thumbs.querySelectorAll('.pgal__thumb').forEach((b) => b.classList.toggle('is-active', b === btn));
  });
})();

// ── Purchase buttons: set SHOP_URL once the Shopify store is live ──
// The nav/hero "Jetzt kaufen" buttons scroll to the #produkt buy box; these two are the
// actual checkout links and open the shop when SHOP_URL is filled in.
const SHOP_URL = ''; // e.g. 'https://spuma.ro' (Shopify)
if (SHOP_URL) {
  document.querySelectorAll('#buyProd, #buyBtn').forEach((el) => {
    el.setAttribute('href', SHOP_URL);
    el.setAttribute('target', '_blank');
    el.setAttribute('rel', 'noopener');
  });
}


// ── Buy buttons that only scroll (nav / hero / banners) ──
// Real checkout happens through the product form; these are in-page anchors and
// need no wiring. Kept here so the file documents the whole flow.

// ── Login page: toggle the password-recovery form ──
(function () {
  var login = document.getElementById('login');
  var recover = document.getElementById('recover');
  if (!login || !recover) return;
  var show = function (which) {
    login.style.display = which === 'login' ? '' : 'none';
    recover.style.display = which === 'recover' ? '' : 'none';
  };
  if (window.location.hash === '#recover') show('recover');
  document.querySelectorAll('[data-toggle-recover]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      show(recover.style.display === 'none' ? 'recover' : 'login');
    });
  });
})();

// ── Product form: keep the button label in sync with the chosen variant ──
(function () {
  var select = document.getElementById('buyVariant');
  var button = document.getElementById('buyProd');
  if (!select || !button) return;
  var base = button.textContent.split('\u00b7')[0].trim();
  select.addEventListener('change', function () {
    var opt = select.options[select.selectedIndex];
    var price = opt.getAttribute('data-price');
    button.disabled = opt.disabled;
    if (price) button.textContent = base + ' \u00b7 ' + price + ' \u26a1';
  });
})();
